import API from 'services/api.services';
import {
	API_DOWNLOAD_REPORT,
	API_GET_REPORTS_CATALOG,
} from 'constants/db.constants';
import {
	IReportCatalogItem,
	ReportFormat,
	ReportKey,
	ReportLocale,
	setCatalog,
	setLoading,
	setMessage,
} from 'state/reducers/reports.reducers';
import { intialMessage } from 'constants/ui.constants';
import { setErrorMessage } from 'utils';

export type ReportRenderFilters =
	| Record<string, never>
	| { date: string }
	| { startDate: string; endDate: string }
	| { beneficiaryId: number; startDate: string; endDate: string }
	| { scope: 'all' }
	| { scope: 'byCreationDate'; startDate: string; endDate: string }
	| { paymentId: number };

export type ReportRenderRequest = {
	reportKey: ReportKey;
	locale: ReportLocale;
	format: ReportFormat;
	filters: ReportRenderFilters;
};

export function fetchReportsCatalog() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));

		try {
			const response = await API.getInstance().get(API_GET_REPORTS_CATALOG);
			const reports = (response.data?.reports || []) as IReportCatalogItem[];
			dispatch(setCatalog(reports));
			return reports;
		} catch (error: any) {
			dispatch(setCatalog([]));
			setErrorMessage(setMessage, error);
			return [];
		} finally {
			dispatch(setLoading(false));
		}
	};
}

export function downloadReport(params: ReportRenderRequest) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));

		try {
			const response = await API.getInstance().post(
				API_DOWNLOAD_REPORT,
				params,
				{ responseType: 'blob' },
				{ 'Content-Type': 'application/json' }
			);
			return response;
		} catch (error: any) {
			if (error?.data instanceof Blob) {
				try {
					const text = await error.data.text();
					const parsed = JSON.parse(text);
					setErrorMessage(setMessage, { ...error, data: parsed });
				} catch {
					setErrorMessage(setMessage, error);
				}
			} else {
				setErrorMessage(setMessage, error);
			}
			return null;
		} finally {
			dispatch(setLoading(false));
		}
	};
}
